import { RefObject } from 'react';

import { Reviews, Location } from '@virginexperiencedays/products';
import { cn } from '@virginexperiencedays/tailwind';

import { IconStarSmall } from '../../../icons/IconStarSmall';
import { StarRating } from '../../../StarRating';

type Props = {
  reviews?: Pick<Reviews, 'averageRating' | 'count'>;
  locations?: Location[];
  reviewsRef?: RefObject<HTMLDivElement>;
  locationsRef?: RefObject<HTMLDivElement>;
  className?: string;
  isCollectionProduct?: boolean;
};

export const ProductMetaDetails = ({
  reviews,
  locations,
  reviewsRef,
  locationsRef,
  className,
  isCollectionProduct,
}: Props) => {
  const showReviews = reviews && reviews.count > 0 && !isCollectionProduct;
  const showLocations = locations && locations.length > 0;

  if (!showReviews && !showLocations) return <></>;

  const scrollToRef = (ref: RefObject<HTMLDivElement>) => {
    ref?.current?.scrollIntoView({ behavior: 'smooth' });
    /* patch animation for lazy loaded layout shift, temporary solution until 
       we can refactor lazy loaded components for PDP (AddtionalDetails & Reviews) */
    setTimeout(function () {
      ref?.current?.scrollIntoView({ behavior: 'smooth' });
    }, 1500);
  };

  return (
    <div
      className={cn(
        'flex items-center gap-2 text-sm',
        'first:children:before:hidden children:before:bg-border-neutral children:before:mr-2 children:before:h-[5px] children:before:w-[5px] children:before:rounded',
        className
      )}
    >
      {showReviews && (
        <div className="flex items-center before:hidden">
          <button
            className="flex cursor-pointer items-center border-0 bg-transparent p-0"
            aria-label="Scroll to reviews"
            onClick={() => {
              scrollToRef(reviewsRef);
            }}
          >
            <StarRating rating={reviews.averageRating} Icon={IconStarSmall} />
            <span className="text-neutral-faded ml-1 font-medium leading-none">
              (<span className="underline">{reviews.count}</span>)
            </span>
          </button>
        </div>
      )}
      {showLocations && (
        <div className="flex items-center">
          <button
            className="text-neutral flex cursor-pointer border-0 bg-transparent p-0 font-medium leading-none underline"
            aria-label="Scroll to locations"
            onClick={() => {
              scrollToRef(locationsRef);
            }}
          >
            {`${locations.length} ${locations.length > 1 ? 'Locations' : 'Location'} in the UK`}
          </button>
        </div>
      )}
    </div>
  );
};
